import { LocationDTO, dtoToModel as toLocationModel } from './location';
import { TimestampedDTO, dtoToModelDef } from './timestamped';
import { buildMapper, Mapper } from '@core/utils/object-helpers';
import { UnitLocation } from '@core/models/unit-location.model';

export interface UnitLocationDTO extends TimestampedDTO {
    id?: number,
    unitId?: number,
    locationId?: number,
    observation?: string,
    date?: string,
    location?: LocationDTO
}

export const dtoToModel: Mapper<UnitLocationDTO, UnitLocation>  = buildMapper<UnitLocationDTO, UnitLocation>({
    mappings: {
        date: value => value ? new Date(value) : undefined,
        location: value => value ? toLocationModel(value) : undefined,
        ...dtoToModelDef,
    },
});
